module.exports = __webpack_public_path__ + "img/check-blue.1e05b7bf.svg";